// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__SZIBS","info":"Note_info__3wnSv","note":"Note_note__1BEAu","actions":"Note_actions__2za74"};